import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage if present (fallback for cookie)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kasir_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  return `${API_BASE}/files/${path}`;
}

export function formatRupiah(n) {
  if (n == null || isNaN(n)) return "Rp0";
  return "Rp" + Math.round(n).toLocaleString("id-ID");
}
